var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame98(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 10,
    fill: "#7858F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.204 10.99L16.7391 6.46244C16.8194 6.39566 16.8796 6.30885 16.9197 6.202C16.9732 6.09516 17 5.98164 17 5.86144C17 5.62104 16.913 5.4207 16.7391 5.26043C16.5786 5.08681 16.3846 5 16.1572 5C16.0234 5 15.903 5.02671 15.796 5.08013C15.7023 5.1202 15.6154 5.1803 15.5351 5.26043L11 9.78798L6.46488 5.26043C6.38462 5.19366 6.29097 5.14023 6.18395 5.10017C6.0903 5.04674 5.98997 5.02003 5.88294 5.02003C5.64214 5.02003 5.43478 5.10684 5.26087 5.28047C5.10033 5.44073 5.02007 5.64107 5.02007 5.88147C5.02007 5.98831 5.04013 6.09516 5.08027 6.202C5.1204 6.30885 5.1806 6.40234 5.26087 6.48247L9.79599 10.99L5.26087 15.5175C5.1806 15.5977 5.11371 15.6912 5.0602 15.798C5.02007 15.9048 5 16.0184 5 16.1386C5 16.379 5.08027 16.586 5.2408 16.7596C5.41472 16.9199 5.61538 17 5.84281 17C5.97659 17 6.0903 16.98 6.18395 16.9399C6.29097 16.8865 6.38462 16.8197 6.46488 16.7396L11 12.212L15.5351 16.7195C15.6154 16.7997 15.7023 16.8598 15.796 16.8998C15.903 16.9399 16.01 16.9599 16.1171 16.9599C16.3579 16.9599 16.5585 16.8798 16.7191 16.7195C16.893 16.5459 16.9799 16.3456 16.9799 16.1185C16.9799 15.9983 16.9599 15.8915 16.9197 15.798C16.8796 15.6912 16.8194 15.5977 16.7391 15.5175L12.204 10.99Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame98);
export default __webpack_public_path__ + "static/media/Frame 98.e2dcd018866a097cce417b77fdfd8af2.svg";
export { ForwardRef as ReactComponent };